import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { TITLE_OBJECT_TYPE_GROUP } from 'constants/Mapping.constants';
import intl from 'i18n/intl';
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';
import { Typography } from '@timeedit/ui-components/antd';
import AddNewObjectType from '../../../components/AppService/ObjectTypes/AddNewObjectTypes';
import ObjectTypeMapping from '../../../components/AppService/ObjectTypes/ObjectTypeMapping';
import {
  appServicePreferencesObjectTypes,
  fetchPreferencesMappingSettings,
  fetchRawObjectFields,
} from '../../../slices/appService.slice';
import MappingValidation from './MappingValidation';
import './objectTypes.scss';

const language: any = intl.messages;

const { Text } = Typography;

const ObjectTypes = () => {
  const dispatch = useAppDispatch();
  // Store local copy of integration settings in component state
  const storeResource = useSelector(appServicePreferencesObjectTypes);
  const [resource, setResource] = useState(storeResource);
  /**
   * EFFECTS
   */
  useEffect(() => {
    setResource(storeResource);
  }, [storeResource]);

  useEffect(() => {
    dispatch(fetchPreferencesMappingSettings());
    dispatch(fetchRawObjectFields('tePreferences'));
  }, []);

  /**
   * EVENT HANDLERS
   */
  return (
    <DefaultContentLayout
      title={language.preferences_settings}
      subtitle={language.object_types}
    >
      <div
        className="inner-content--wrapper allow-scroll"
        style={{ padding: 15, display: 'block' }}
      >
        <AddNewObjectType
          appName={'tePreferences'}
          allowedMappingModes={['FREE_MAPPING']}
          objectTypes={resource}
        />
        <div className="object-type-mappings-header">
          <div className="object-type-mappings-header__label">
            <Text>Label</Text>
          </div>
          <div className="object-type-mappings-header__label">
            <Text>Property name</Text>
          </div>
          <div className="object-type-mappings-header__label">
            <Text>{TITLE_OBJECT_TYPE_GROUP}</Text>
          </div>
          <div className="object-type-mappings-header__label object-type-mappings-header__label--center">
            <Text>Status</Text>
          </div>
          <div className="object-type-mappings-header__label"></div>
        </div>
        {resource.map((objectType: any, objectTypeIdx: number) => (
          <ObjectTypeMapping
            key={objectType.objectTypeExtId + objectTypeIdx}
            objectType={objectType}
            appName={'tePreferences'}
            allowedMappingModes={['FREE_MAPPING']}
            objectTypeIdx={objectTypeIdx}
          />
        ))}
        <MappingValidation objectTypes={resource} />
      </div>
    </DefaultContentLayout>
  );
};

export default ObjectTypes;
